export default function TickIconWithBorder() {
  return (
    <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.166 22C17.666 22 22.166 17.5 22.166 12C22.166 6.5 17.666 2 12.166 2C6.66602 2 2.16602 6.5 2.16602 12C2.16602 17.5 6.66602 22 12.166 22Z"
        stroke="#FDFDFF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M7.91602 11.9999L10.746 14.8299L16.416 9.16992" stroke="#FDFDFF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
}
